var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transfer-cmp"},[(_vm.ziduan['label'] == '单选')?_c('div',{staticClass:"transfer"},[_c('Danxuan',{attrs:{"ziduan":_vm.ziduan,"index":_vm.index},on:{"ziduanChange":_vm.ziduanChange}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }